import qs from 'querystring'
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'
import * as tip from '../../../../../uis/tip/reduces'

//constant
const API_PREFIX = '/todo-task'

const NAME_PREFIX = 'TODO_TASK';

const DEFAULT_SIZE = 10

const RECEIVE_LIST = `${NAME_PREFIX}_RECEIVE_LIST`

const RECEIVE_DETAIL = `${NAME_PREFIX}_RECEIVE_DETAIL`

export const CHANGE_PAGE = `${NAME_PREFIX}_CHANGE_PAGE`

export const CHANGE_QUERY = `${NAME_PREFIX}_CHANGE_QUERY`

export const SHOW_MODAL = `${NAME_PREFIX}_SHOW_MODAL`

export const HIDE_MODAL = `${NAME_PREFIX}_HIDE_MODAL`

export const CHANGE_FILTER_LIST = `${NAME_PREFIX}_CHANGE_FILTER_LIST`

export const RECEIVE_ALLS_LIST = `${NAME_PREFIX}_RECEIVE_ALLS_LIST`

function trimForm(formData) {
    const newFormData = {};
    Object.keys(formData).forEach(key=>{
        const value = formData[key];
        if (typeof(value) === 'string') {
            newFormData[key] = value.trim();
        } else {
            newFormData[key] = value;
        }
    })
    return newFormData;
}
//action
function getData(params, dispatch, form) {
    return http.post(`${API_PREFIX}/list?${qs.stringify(params)}`, form)
        .then(data => {
            dispatch({
                type: RECEIVE_LIST,
                data: data.data
            })
        })
}
export function getFormData(query, filterList) {
    const form = {
        "logic": "and",
        "filters": []
    }
    const keys = Object.keys(query);
    keys.forEach(key=>{
        if (query[key]) {
            if (key === 'status') {
                form.filters.push({
                    "field": "status",
                    "operator": "eq",
                    "value": query[key]
                })
            } else if (key === 'type') {
                form.filters.push({
                    "field": "type",
                    "operator": "eq",
                    "value": query[key]
                })
            } else {
                form.filters.push({
                    "field": key,
                    "operator": filterList.find(item=>item.value === key).operator,
                    "value": query[key]
                })
            }
        }
    })
    return form;
}

export function getList() {
    return (dispatch,getState) => {
        const {todoTask: {page, query, filterList}} = getState()
        const data = {
            page: page.index,
            size: page.size,
            sort: page.sort
        }
        const form = getFormData(query, filterList);
        getData(data, dispatch, form)
    };
}

export function add(formData) {
    return (dispatch, getState) => {
        if (!formData.described) {
            return dispatch(tip.error('待办内容不能为空'));
        }
        if (!formData.currentAccountId) {
            return dispatch(tip.error('执行人不能为空'));
        }
        return http.post(`${API_PREFIX}/add`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function remove(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/delete/${id}`)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}
export function update(formData) {
    return (dispatch, getState) => {
        console.info(formData);
        return http.post(`${API_PREFIX}/update/${formData.id}`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function showUpdateModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'update', id})
            })
    }
}

export function getAlls() {
    return (dispatch, getState) => {
        return http.get(`/user/alls`)
            .then((data) => {
                console.info(data.data);
                dispatch({type: RECEIVE_ALLS_LIST, data: {alls: data.data.map(item => {
                    return {
                        ...item,
                        label: item.name,
                        value: item.id
                    }
                })}})
                
            })
    }
}

//reducers
const initialState = {
    list: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE,
        sort: "dueTime"
    },
    total: 0,
    alls: [],
    showModal: {
        add: false,
        delete: false,
        update: false,
        id: null
    },
    detail: {},
    filterList: [
        {"name": "执行人", "componentType": "Text", "data": [], "isShow": true, "value": "currentAccountName", "operator": "contains"}
    ],
    query: {
        status: "新增"
    }
}

export default createReducer(initialState,{
    [RECEIVE_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [RECEIVE_ALLS_LIST]: (state, {data}) => {
        return {...state, ...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [SHOW_MODAL]: (state,{key,id}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal}
    },
    [CHANGE_FILTER_LIST]: (state,{value}) => {
        return {...state,filterList: value}
    },
    [CHANGE_QUERY]: (state,{key,value}) => {
        return {...state,query: {...state.query,[key]: value}, page: {index: 0, size: DEFAULT_SIZE}}
    },
    [RECEIVE_DETAIL]: (state, {detail}) => {
        return {...state, detail}
    }
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/todo_task/reducers/list.js